import { defineMessages } from 'react-intl';

export default defineMessages({
  submit: 'Submit',
  email: 'E-mail',
  emailRequired: 'E-mail required!',
  login: 'Back to login',
  successTitle: 'Check your inbox!',
  successMessage: 'We\'ve just sent you an email to reset your password.',
  errorTitle: 'Something went wrong',
  errorMessage: 'We couldn\'t complete request. Please try again later.',
});
